import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';

const CompanyAdd = (props) => {
  console.log(props)
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
// MainTransferID	
// UserID	
// TransferDate	
// FromShopID	
// ToShopID
const updateMainSecionsValue = (valueObj) => {
  setInputProps((prevValues) => {
    const updatedValues = { ...prevValues };

    Object.keys(valueObj).forEach((key) => {
      if (updatedValues[key]) {
        updatedValues[key] = {
          ...updatedValues[key],
          ...valueObj[key], // Spread the inner object to update its properties
        };
      }
    });

    return updatedValues;
  });
};
const [inputProps, setInputProps] = useState({
  CompanyID: { name: 'CompanyID', value: props.CompanyID || '', enabled: false },
  CompanyName: { name: 'CompanyName', value: props.CompanyName || '' },
  CompanyAddress: { name: 'CompanyAddress', value: props.CompanyAddress || '' },
  CompanyTradeLicenseNo: { name: 'CompanyTradeLicenseNo', value: props.CompanyTradeLicenseNo || '' },
  CompanyLogo: { name: 'CompanyLogo', value: props.CompanyLogo || '' },
  ClientID: { name: 'ClientID', value: props.ClientID || '' },
  RepresentedBy: { name: 'RepresentedBy', value: props.RepresentedBy || '' },
  ReceivableAccountCode:{
    name:{id:'AccountIDReceivable',value:'ReceivableAccountCode'},
    caption: 'Select Receivable Account',
    value: {id: props.AccountIDReceivable || 'undefined' ,value:props.ReceivableAccountCode || ''},
    dataSource: {type:'Route',route:'CompanyReceivableAccount'},
    addNew: { Route: 'ReceivableAccountList', Security: 'Receivable Accounts' },

  },
  PayableAccountCode:{
    name:{id:'AccountIDPayable',value:'PayableAccountCode'},
    caption: 'Select Payable Account',
    value: {id: props.AccountIDPayable  ,value:''},
    dataSource: {type:'Route',route:'CompanyPayableAccount'},
    // addNew: { Route: 'AgentAccounts', Security: 'AgentAccounts' },


  },
    
  // ReceivableAccountCode: { name: 'ReceivableAccountCode', value: props.ReceivableAccountCode || '' }
});

// EXTRA CODE START
const [imagePreview, setImagePreview] = useState(props.CompanyLogo);  // State to hold the preview image

// useEffect(() => {
//   if (props.CompanyLogo && props.CompanyLogo.data) {
//     const reader = new FileReader();
    
//     reader.onloadend = () => {
//       setImagePreview(reader.result); // Save the preview image in state
//     };
    
//     reader.readAsDataURL(props.CompanyLogo); 
//   }
// }, [props.CompanyLogo]); // Re-run if CompanyLogo prop changes

// Handle file input change (selection of a file)
const handleFileChange = (e) => {
  console.log(e)
  e.preventDefault()
  const file = e.target.files[0]; // Get the first file from the input

  if (file && file.type.startsWith('image/')) {
    // Create a FileReader to read the file
    const reader = new FileReader();
    
    reader.onloadend = () => {
      console.log(reader.result)
      setImagePreview(reader.result); // Save the preview image in state
      updateMainSecionsValue( {CompanyLogo:{value:reader.result}});

    };
    
    reader.readAsDataURL(file);  // Convert the file to a base64 string (data URL)
  } else {
    alert('Please select a valid image file!');
  }
};
// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    { Input: TextComponent, Props: { ...inputProps.CompanyName, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.CompanyAddress, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.CompanyTradeLicenseNo, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.ClientID, setInputProps }, ColumnSize: 0 },
    { Input: TextComponent, Props: { ...inputProps.RepresentedBy, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.ReceivableAccountCode, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.PayableAccountCode, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.CompanyLogo, setInputProps }, ColumnSize: 0 },
    { Input: () => {
      return (
        <div className='main-image-upload'>
          <div className="image-uploader">
            <label htmlFor="file-upload" className="custom-file-upload">
              Upload Logo
            </label>
            <input
              id="file-upload"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="file-input"
              multiple={false}
            />
          </div>
    
          {/* Image preview section */}
          <div className="image-upload-container">
            {imagePreview ? (
              <div className="image-preview">
                <img
                  style={{ maxHeight: '200px', objectFit: 'contain' }}
                  src={imagePreview}
                  alt="Preview"
                  className="preview-image"
                />
              </div>
            ) : (
              <p>No image to display.</p>
            )}
          </div>
        </div>
      );
    }
    , Props: {  }, ColumnSize: 6 },
    
];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={{...props , isAdd:true}} title={`Company ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default CompanyAdd;
